import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import {
	Breakpoint,
	Button,
	Container,
	DataGrid,
	Heading3,
	Paragraph,
	Select,
	Separator,
	Skeleton,
	tokens,
} from '@treams/treams-ui';

const AnalyticsCard = styled(Box)`
	border-radius: ${tokens.radius.md}px;
	background-color: ${tokens.surface.white};
	box-shadow: ${tokens.shadow.xs};
	border: 1px solid ${tokens.border.subtle};
	box-sizing: border-box;
	min-width: 0;
	overflow: hidden;
`;

const TopCardsGrid = styled(Box)`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: ${tokens.gap.group}px;

	@media screen and (max-width: ${Breakpoint.Medium}) {
		grid-template-columns: minmax(0, 1fr);
	}
`;

const DoughnutSkeleton = styled(Skeleton.Box)`
	width: 80px;
	height: 80px;
	border-radius: 50%;
`;

export function CycleAnalyticsSkeleton() {
	return (
		<Container py={4} wide={true} minWidth={0}>
			<TopCardsGrid mb={`${tokens.gap.section}px`}>
				<AnalyticsCard>
					<Box p={3}>
						<Heading3.Skeleton />
						<Paragraph.Skeleton lines={1} mt={2} />
						<Box mt={3} mx={3}>
							<Flex alignItems="center">
								<Flex mr={4} width={5 / 12} flexDirection="column" alignItems="center">
									<DoughnutSkeleton />
									<Paragraph.Skeleton lines={1} mt={2} width={140} />
								</Flex>
							</Flex>
						</Box>
					</Box>
				</AnalyticsCard>

				<AnalyticsCard>
					<Box p={3}>
						<Heading3.Skeleton mb={2} />
						<Paragraph.Skeleton lines={1} mt={2} />
						<Paragraph.Skeleton lines={1} mt={2} />
					</Box>
				</AnalyticsCard>
			</TopCardsGrid>

			<AnalyticsCard mb={`${tokens.gap.section}px`}>
				<Box p={3}>
					<Heading3.Skeleton />
				</Box>
				<DataGrid.Skeleton columns={5} rows={4} />
			</AnalyticsCard>

			<AnalyticsCard mb={`${tokens.gap.section}px`}>
				<Box p={3}>
					<Heading3.Skeleton />
					<Flex mt={3}>
						<Select.Skeleton />
					</Flex>
				</Box>
				<DataGrid.Skeleton columns={6} rows={6} />
				<Box pb={3}>
					<Separator />
					<Flex mt={3} mx={3}>
						<Button.Skeleton />
					</Flex>
				</Box>
			</AnalyticsCard>

			<AnalyticsCard>
				<Box p={3}>
					<Heading3.Skeleton />
					<Paragraph.Skeleton lines={1} mt={2} />
				</Box>
				<DataGrid.Skeleton columns={4} rows={6} />
			</AnalyticsCard>
		</Container>
	);
}
